module.exports = __webpack_public_path__ + "static/media/logo_orange_l.59a12e3f.png";